import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './GameCard.css';

function GameCard({ game, onPlay }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handlePlayClick = (e) => {
    e.preventDefault();
    onPlay(game);
  };

  // Generate slug from game name
  const gameSlug = game.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const gameUrl = `/game/${gameSlug}`;

  return (
    <div className="game-card">
      <Link to={gameUrl} className="game-card-link" onClick={handlePlayClick}>
        <div className="game-image-container">
          {!imageLoaded && !imageError && (
            <div className="image-placeholder">Loading...</div>
          )}
          {imageError && (
            <div className="image-placeholder">🎮</div>
          )}
          <img
            src={game.image || game.logo}
            alt={`${game.name} - Free ${game.gameType || 'Casino'} Game by ${game.provider?.name || 'Provider'}`}
            title={`Play ${game.name} for free`}
            className={`game-image ${imageLoaded ? 'loaded' : ''}`}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageError(true)}
            loading="lazy"
          />
          <div className="game-overlay">
            <button className="play-button">
              ▶ Play Now
            </button>
          </div>
        </div>
        <div className="game-info">
          <h3 className="game-name" title={game.name}>{game.name}</h3>
          <div className="game-meta">
            {game.provider?.name && (
              <span className="game-provider">{game.provider.name}</span>
            )}
            {game.rtp && (
              <span className="game-rtp">RTP: {game.rtp}%</span>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default GameCard;
